import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';
import { get } from 'lodash-es';
import { CommonModule } from '@angular/common';
class InheritStyleDirective {
  constructor(elementRef, renderer) {
    this.elementRef = elementRef;
    this.renderer = renderer;
  }
  ngAfterViewChecked() {
    const element = get(this.elementRef, 'nativeElement', null);
    if (!element) {
      console.error('Could not find elementRef.nativeElement.');
      return;
    }
    if (this.level === 0) {
      console.error('Element already has its own _ngcontent-* attribute, please check the package ReadMe for more info.');
      return;
    }
    // _ngcontent-* is always at index 0 of attributes
    this.ngContentRef = get(element, 'attributes[0].name', null);
    const nodeList = get(element, 'childNodes', []);
    this.assignNgContentRef(nodeList, 0);
  }
  assignNgContentRef(nodeList, level) {
    if (!nodeList || level === this.level) {
      return;
    }
    nodeList.forEach(node => {
      if (get(node, 'nodeType', 0) === Node.ELEMENT_NODE) {
        this.renderer.setAttribute(node, this.ngContentRef, '');
        if (get(node, 'childNodes', [])) {
          this.assignNgContentRef(node.childNodes, level + 1);
        }
      }
    });
  }
  static {
    this.ɵfac = function InheritStyleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InheritStyleDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: InheritStyleDirective,
      selectors: [["", "uprInheritStyle", ""]],
      inputs: {
        level: "level"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InheritStyleDirective, [{
    type: Directive,
    args: [{
      selector: '[uprInheritStyle]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    level: [{
      type: Input
    }]
  });
})();
class InheritStyleModule {
  static {
    this.ɵfac = function InheritStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InheritStyleModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: InheritStyleModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InheritStyleModule, [{
    type: NgModule,
    args: [{
      declarations: [InheritStyleDirective],
      imports: [CommonModule],
      exports: [InheritStyleDirective]
    }]
  }], null, null);
})();

/*
 * Public API Surface of inherit-style
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InheritStyleDirective, InheritStyleModule };
